var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(-76 -42.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    className: "active",
    "data-name": "Path 88",
    d: "M89,48.5a3.179,3.179,0,0,1-.06.62,3.478,3.478,0,0,1-1.3,2.15A3.591,3.591,0,0,1,85.5,52a3.5,3.5,0,0,1-3.44-2.88A3.179,3.179,0,0,1,82,48.5a3.472,3.472,0,0,1,2.04-3.17,3.395,3.395,0,0,1,2.92,0A3.472,3.472,0,0,1,89,48.5Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    className: "active",
    "data-name": "Path 89",
    d: "M90.5,57.5V61h-10V57.5a.34.34,0,0,1,.01-.1A3.488,3.488,0,0,1,84,54h3a3.488,3.488,0,0,1,3.49,3.4A.34.34,0,0,1,90.5,57.5Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M82,48.5a3.179,3.179,0,0,0,.06.62A3.105,3.105,0,0,1,81,49.3a3.15,3.15,0,1,1,3.04-3.97A3.472,3.472,0,0,0,82,48.5Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M85.43,54H84a3.488,3.488,0,0,0-3.49,3.4H76.5V54.25a3.15,3.15,0,0,1,3.15-3.15h1.01a5.453,5.453,0,0,0,1.46,1.74,5.774,5.774,0,0,0,1.54.85,5.191,5.191,0,0,0,1.5.3A2.437,2.437,0,0,0,85.43,54Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M93.15,46.15A3.15,3.15,0,0,1,90,49.3a3.105,3.105,0,0,1-1.06-.18A3.179,3.179,0,0,0,89,48.5a3.472,3.472,0,0,0-2.04-3.17,3.149,3.149,0,0,1,6.19.82Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M94.5,54.25V57.4H90.49A3.488,3.488,0,0,0,87,54H85.57c.09,0,.18-.01.27-.01a4.954,4.954,0,0,0,1.51-.32,5.132,5.132,0,0,0,1.51-.82,5.321,5.321,0,0,0,1.48-1.75h1.01A3.15,3.15,0,0,1,94.5,54.25Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4cbd1939830c649a01369a497ffb9c58.svg";
export { ForwardRef as ReactComponent };